<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('quality_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-quality-high</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-quality-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.quality.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('profile.quality.focus') }}</strong></td>
              <td>
                                    {{ item['focus'].name }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.quality.layer') }}</strong></td>
              <td>
                                    {{ item['layer'].height }}
              </td>

              <td><strong>{{ $t('profile.quality.nozzleout') }}</strong></td>
              <td>
                                    {{ item['nozzleOut'].size }}
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Quality';

export default {
  name: 'QualityShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('quality', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('quality', ['find'])
  },
  methods: {
    ...mapActions('quality', {
      deleteItem: 'del',
      reset: 'reset',
      update : 'update',
      retrieve: 'load'
    })
  }
};
</script>
